import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, isVerifyEmail, logout} from "../../../features/user";
//import { setLoading} from "../../features/common";
import { useTranslation } from 'react-i18next';
import {checkValidToken, userLoggedIn, navigateTo} from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import ListCard from '../../widgets/ListCard';

export function Home() {
    const [state, setState] = useState({ search: "" });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        checkValidToken(navigate, dispatch, false, true, "/start");
        userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch);
       // eslint-disable-next-line
    },[]);


    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.id]: e.target.value,
        });
    };

    const search = (e) => {
        if((state.search).trim().length > 0) {
            navigateTo(dispatch, navigate, `/providers/search/${(state.search).trim()}`)
        }
    };

    return (
        <Frame headerWhite={true} showMenu={true} showNav={true}>
            <div className='main main-home'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                    <Background >
                        <div className='right-main-inner'>
                            <div className='text-align-center font-18 color-550952'>{t("have_you_written_a_book")}</div>
                            <div className='text-align-center font-18 color-550952'>{t("whats_next")}</div>
                            <div className='mt20 input'>
                                <img src='/images/home/search.png' className='input-icon ml5' onClick={(e) => search(e)} alt=''/>
                                <img src='/images/input_spacer.png' className='input-spacer' alt=''/>
                                <input type="text" id="search" placeholder={t("search_for_a_specific_provider")} value={state.search} onChange={(e) => handleChange(e)} />
                            </div>
                            <ListCard title={"popular"} items={[{name:"content_editing"}, {name:"cover_design"}, {name:"beta_readers"}]}></ListCard>
                            
                            <div className='mt20 home-icons'>
                                <div className='home-icon-wrapper' onClick={() => navigateTo(dispatch, navigate, '/edit-list')}>
                                    <img src='/images/home/edit_button.png' className='home-icon' alt=''/>
                                    <div className='text-align-center font-15 font-bold color-550952'>{t("edit_provider")}</div>
                                </div>
                                <div className='home-icon-wrapper' onClick={() => navigateTo(dispatch, navigate, '/graphic-list')}>
                                    <img src='/images/home/graphic_button.png' className='home-icon' alt=''/>
                                    <div className='text-align-center font-15 font-bold color-550952'>{t("graphic_provider")}</div>
                                </div>
                            </div>

                            <div className='mt20 home-icons'>
                                <div className='home-icon-wrapper' onClick={() => navigateTo(dispatch, navigate, '/marketing-list')}>
                                    <img src='/images/home/marketing_button.png' className='home-icon' alt=''/>
                                    <div className='text-align-center font-15 font-bold color-550952'>{t("marketing_provider")}</div>
                                </div>
                                <div className='home-icon-wrapper' onClick={() => navigateTo(dispatch, navigate, '/print-list')}>
                                    <img src='/images/home/print_button.png' className='home-icon' alt=''/>
                                    <div className='text-align-center font-15 font-bold color-550952'>{t("print_provider")}</div>
                                </div>
                            </div>

                        </div>
                    </Background>
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}